var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSnagitLogo = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  "data-name": "Layer 1",
  viewBox: "0 0 512 512"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "SnagitLogo_svg__a",
  x1: 256,
  x2: 256,
  y1: 514,
  y2: 2,
  gradientTransform: "matrix(1 0 0 -1 0 514)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#68b0db"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#468cc3"
})))), /*#__PURE__*/React.createElement("g", {
  "data-name": "Snagit Icon 256px"
}, /*#__PURE__*/React.createElement("rect", {
  width: 512,
  height: 512,
  rx: 50,
  style: {
    fill: "url(#SnagitLogo_svg__a)"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M93 140h78v77H93zM341 295h78v77h-78z",
  style: {
    fill: "#d8ebf6"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "m155.7 374.42-60.41 62A8 8 0 0 0 101 450h238.68a8 8 0 0 0 5.73-2.42L419.05 372H161.43a8 8 0 0 0-5.73 2.42M356.36 137.58l60.41-62A8 8 0 0 0 411 62H172.37a8 8 0 0 0-5.73 2.42L93 140h257.63a8 8 0 0 0 5.73-2.42M345.38 219.42a8 8 0 0 0-5.73-2.42H93l73.64 75.58a8 8 0 0 0 5.73 2.42H419Z",
  style: {
    fill: "#fff"
  }
})));
export default SvgSnagitLogo;